import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchCustomizedTrips = async (type) => {
  try {
    const response = await fetch(
      `${API_URL}/tour_list?type=${type}`,   // 🔥 TYPE ADD KIYA
      {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        },
      }
    );

    return await response.json();
  } catch (error) {
    console.log("API Error:", error);
    return null;
  }
};